import { render, staticRenderFns } from "./InProgress.vue?vue&type=template&id=2b75e9a1&scoped=true"
import script from "./InProgress.ts?vue&type=script&lang=ts&external"
export * from "./InProgress.ts?vue&type=script&lang=ts&external"
import style0 from "./InProgress.vue?vue&type=style&index=0&id=2b75e9a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75e9a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b75e9a1')) {
      api.createRecord('2b75e9a1', component.options)
    } else {
      api.reload('2b75e9a1', component.options)
    }
    module.hot.accept("./InProgress.vue?vue&type=template&id=2b75e9a1&scoped=true", function () {
      api.rerender('2b75e9a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/pages/InProgress/InProgress.vue"
export default component.exports